<template>
  <div
    class="
      q-mx-lg q-my-xs q-px-md q-pt-xs
      row
      justify-between
      items-center
      bg-grey-1
      rounded-borders
      full-width
      no-wrap
    "
    style="min-height: 80px"
  >
    <div class="text-grey-10 column no-wrap ellipsis col-3">
      <div class="text-bold text-subtitle1 no-wrap ellipsis">
        {{ sample.detail.name }}
      </div>
      <div class="text-caption text-weight-light">
        {{ sample.detail.usccode }}
      </div>
    </div>
    <div class="text-bold text-subtitle1 no-wrap ellipsis text-primary col-2">
      {{ sample.detail.tel }}
      <q-tooltip>
        {{ sample.detail.tel }}
      </q-tooltip>
    </div>

    <div class="text-caption text-bold q-mr-md ellipsis-3-lines col-1">
      {{ sample.detail.industryphy_cn }}
    </div>

    <div class="text-caption q-ml-xs ellipsis-3-lines col-2">
      {{ sample.detail.dom }}
    </div>

    <!-- 操作部分 -->
    <div class="col-1">
      <q-btn color="primary" flat @click="showMoreDetailDialog = true">
        <q-icon name="fas fa-ellipsis-h" size="0.8rem" />
        <q-tooltip> 查看更多信息 </q-tooltip>
      </q-btn>

      <q-btn color="primary" flat @click="showNoteDialog = true">
        <q-icon name="fas fa-pen" size="0.8rem" />
        <q-tooltip> 添加备注信息 </q-tooltip>
      </q-btn>
    </div>

    <div class="q-px-sm q-mt-sm col-3 row">
      <q-radio
        v-model="sampleTelpStatus"
        val="checked"
        label="有效"
        color="green"
        size="xs"
        @input="updateStatus"
      />
      <q-radio
        v-model="sampleTelpStatus"
        val="invalid"
        label="无效"
        color="red"
        size="xs"
        @input="updateStatus"
      />
      <q-radio
        v-model="sampleTelpStatus"
        val="unchecked"
        label="无法确认"
        color="orange"
        size="xs"
        @input="updateStatus"
      />
    </div>
    <!-- 详情 -->
    <q-dialog v-model="showMoreDetailDialog">
      <q-card style="min-width: 500px">
        <q-card-section class="row items-center justify-between bg-grey-4">
          <!-- <q-avatar icon="signal_wifi_off" color="primary" text-color="white" /> -->
          <span class="q-ml-sm text-subtitle1 text-bold">{{
            sample.detail.name
          }}</span>
          <q-btn
            color="primary"
            icon="fas fa-times"
            flat
            @click="showMoreDetailDialog = false"
          />
        </q-card-section>
        <q-card-section class="q-mx-md" align="lift">
          <!-- {{sample.detail}} -->
          <div class="q-ma-lg">
            <ul class="q-pb-md">
              <span class="text-bold">样本ID：</span>
              {{
                sample.detail.sample_id
              }}
            </ul>
            <ul class="q-pb-md">
              <span class="text-bold">样本名称：</span
              >{{
                sample.detail.name
              }}
            </ul>
            <ul class="q-pb-md">
              <span class="text-bold">是否为小微企业：</span
              >{{
                sample.detail.is_enterprise ? "是" : "不是"
              }}
            </ul>
            <ul class="q-pb-md">
              <span class="text-bold">统一社会信用代码：</span
              >{{
                sample.detail.usccode
              }}
            </ul>
            <ul class="q-pb-md">
              <span class="text-bold">电话：</span
              >{{
                sample.detail.tel
              }}
            </ul>
            <ul class="q-pb-md">
              <span class="text-bold">注册地址：</span
              >{{
                sample.detail.addr ? sample.detail.addr : "缺失"
              }}
            </ul>
            <ul class="q-pb-md">
              <span class="text-bold">经营范围：</span
              >{{
                sample.detail.industryphy_cn
                  ? sample.detail.industryphy_cn
                  : "缺失"
              }}
            </ul>
          </div>
          <div
            v-if="sample.telp_intv && sample.telp_intv.telp_intv_note"
            class="rounded-borders bg-yellow-3 q-pa-lg"
          >
            <span class="text-bold q-pb-md">备注信息:</span><br /><br />
            {{ sample.telp_intv.telp_intv_note }}
          </div>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn flat label="确认" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <!-- 备注 -->
    <q-dialog v-model="showNoteDialog" persistent>
      <q-card style="min-width: 500px">
        <q-card-section class="row items-center justify-between bg-grey-4">
          <!-- <q-avatar icon="signal_wifi_off" color="primary" text-color="white" /> -->
          <span class="q-ml-sm text-subtitle1 text-bold">{{
            sample.detail.name
          }}</span>
          <q-btn
            color="primary"
            icon="fas fa-times"
            flat
            @click="showNoteDialog = false"
          />
        </q-card-section>

        <q-card-section>
          <q-input
            class="full-height"
            style="height: 400px"
            clearable
            filled
            type="textarea"
            v-model="note"
            label="输入一些备注，方便之后的调查进行"
          />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="取消" color="primary" v-close-popup />
          <q-btn
            flat
            label="确认提交"
            color="primary"
            @click="updateTelpIntvSampleNote"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { updateTelpIntvSampleNote } from "../../api/endpoints/sample-telephone-interview/updateTelpIntvSampleNote";
import { updateTelpIntvSampleStatus } from "../../api/endpoints/sample-telephone-interview/updateTelpIntvSampleStatus";
import { SAMPLE_TELP_INTV_CHANGED } from "@/bus/admin.events";
import { EventBus } from "../../bus";

export default {
  data() {
    return {
      sampleTelpStatus: "",
      showMoreDetailDialog: false,
      showNoteDialog: false,
      note: "",
    };
  },
  props: {
    sample: {},
  },
  watch: {
    sample: {
      immediate: true,
      handler() {
        if (this.sample.telp_intv && this.sample.telp_intv.status) {
          this.sampleTelpStatus = this.sample.telp_intv.status;
        } else {
          this.sampleTelpStatus = "";
        }
      },
    },
  },

  methods: {
    async updateTelpIntvSampleNote() {
      try {
        const res = await updateTelpIntvSampleNote(this.sample.id, this.note);
        if (res.status || res.error) {
          this.$q.notify({
            type: "danger",
            message: res.detail || res.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "备注保存成功",
          });
          EventBus.$emit(SAMPLE_TELP_INTV_CHANGED);
          this.showNoteDialog = false;
        }
      } catch (error) {
        console.log(error);
        this.$q.notify({
          type: "danger",
          message: "备注保存失败",
        });
      }
    },
    async updateTelpIntvSampleStatus() {
      // console.log("mmm", this.sampleTelpStatus);
      try {
        const res = await updateTelpIntvSampleStatus(
          this.sample.id,
          this.sampleTelpStatus
        );
        if (res.status || res.error) {
          this.$q.notify({
            type: "danger",
            message: res.detail || res.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: "样本电访状态更新成功",
          });
          EventBus.$emit(SAMPLE_TELP_INTV_CHANGED);
        }
      } catch (error) {
        console.log(error);
        this.$q.notify({
          type: "danger",
          message: "状态更新出现错误，尝试重新登陆",
        });
      }
    },
    async updateStatus() {
      await this.updateTelpIntvSampleStatus();
    },
  },
};
</script>

<style>
</style>